import { render, staticRenderFns } from "./Middle.vue?vue&type=template&id=1a938540&scoped=true&"
import script from "./Middle.vue?vue&type=script&lang=js&"
export * from "./Middle.vue?vue&type=script&lang=js&"
import style0 from "./Middle.vue?vue&type=style&index=0&id=1a938540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a938540",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCardSubtitle,VCardText,VCardTitle,VCol,VImg,VRow,VSkeletonLoader})
